import React from 'react';
import type { IntakeStatusBaseSteps } from '@shared/patient-intake-status';

import { useAuth } from '../../../../../../hooks/index.js';
import { getActionedByName } from '../../../utils';
import { MedicareIHIDetails } from '../../../components';
import { usePatientIntakeStatusContext } from '../../../hooks';

type MedicareVerificationViewerProps = {
  step: IntakeStatusBaseSteps['MEDICARE_VERIFICATION'];
};

export const MedicareVerificationViewer: React.FC<MedicareVerificationViewerProps> = ({ step }) => {
  const { user } = useAuth();
  const { patientId, isHealthcareProvider } = usePatientIntakeStatusContext();

  const verifiedByName = getActionedByName({ currentUserId: user?.uid, step });
  const verifiedAt = step.currentStatus.actionedAt;

  return (
    <MedicareIHIDetails
      hideTitle
      patientId={patientId}
      verifiedByName={isHealthcareProvider ? verifiedByName : null}
      verifiedAt={verifiedAt}
      verificationStatus={step.currentStatus.status}
    />
  );
};
